import { calculateDistanceBetweenTwoPoints } from 'utils/map'
import { CheckingLocationPopupChildProps, Status } from '.'
import React, { useEffect, useRef, useState } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import { useHistory } from 'react-router-dom'
import Popup from '../Popup'

const CheckingLocationPopupBasic: React.FC<CheckingLocationPopupChildProps> = ({ distanceAccuracy, targetPosition, callback }) => {
  const [status, setStatus] = useState<Status>('idle')
  const currentTarget = useRef(targetPosition)
  currentTarget.current = targetPosition
  const currentCallback = useRef(callback)
  currentCallback.current = callback

  const { goBack } = useHistory()

  useEffect(() => {
      if (status !== 'idle') return
      let settled = false
      const watchId = navigator.geolocation.watchPosition(
        pos => {
          if (!settled && pos.coords.accuracy <= distanceAccuracy) {
            settled = true
            navigator.geolocation.clearWatch(watchId)
            if (currentTarget.current) {
              const distance = calculateDistanceBetweenTwoPoints(pos.coords, { latitude: currentTarget.current.lat, longitude: currentTarget.current.lng })
              setStatus(distance <= distanceAccuracy ? 'pending-succeed' : 'pending-failed')
            } else {
              setStatus('pending-failed')
            }
          }
        },
        err => {
          setStatus('pending-failed')
          console.error(err)
        },
        { enableHighAccuracy: true }
      )
  
      const timeoutId = setTimeout(() => {
        if (!settled) {
          navigator.geolocation.clearWatch(watchId)
        }
      }, 15_000)
  
      return () => {
        navigator.geolocation.clearWatch(watchId)
        clearTimeout(timeoutId)
      }
    }, [distanceAccuracy, status])
  
    useEffect(() => {
      if (status === 'succeed' || status === 'failed') {
        const timeout = setTimeout(() => {
          currentCallback.current(status === 'succeed')
        }, 3_000)
        return () => {
          clearTimeout(timeout)
        }
  
      } else if (status === 'pending-succeed' || status === 'pending-failed') {
        const timeout = setTimeout(() => {
          setStatus(status === 'pending-failed' ? 'failed' : 'succeed')
        }, 3_000)
        return () => {
          clearTimeout(timeout)
        }
      }
    }, [status])

  return (
    <Popup
      centered>
      <div className='popup__checkingLocation'>
        <div className='popup__checkingLocation__animation'>
          <i className='icon icon--globe' />
          <div className='popup__checkingLocation__animation__orbit'>
            <i className='icon icon--search cPrimary s40' />
          </div>
        </div>
        <h2>Chwileczkę</h2>
        <p>Musimy sprawdzić czy jesteś na placu</p>
        <ArrowBtn
          enlarged
          showArrow={false}
          text={status === 'failed'
            ? 'Sprawdzanie nie powiodło się!'
            : status === 'succeed'
              ? 'Uruchamianie akcji...'
              : 'Anuluj'}
          action={() => {
            if (status === 'idle') goBack()
          }}
        />
      </div>
    </Popup>
  )
}

export default CheckingLocationPopupBasic